<template>
  <span
    aria-hidden="true"
    class="relative inline-flex h-(--size) w-(--size) shrink-0 rounded-full border-2 bg-white transition"
    :class="{ 'border-current': active, '!border-1': size < 20 }"
    :style="{
      '--size': `${size}px`,
    }"
  >
    <span
      class="absolute inset-[15%] scale-0 rounded-full transition"
      :class="{ 'scale-100 bg-current': active }"
    />
  </span>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    size?: number;
    active?: boolean;
  }>(),
  {
    size: 20,
  },
);
</script>
